import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../comps/Footer";
import Header from "../../comps/Header";
import { API_BASE_URL } from "../../config/Base_Url_Config";
import axios from "axios";
import html2pdf from "html2pdf.js";
import { Link } from 'react-router-dom';
import logo from "../../assets/images/logo.svg";
import { get_settings_section } from '../../api/Global';
import { IMG_BASE_URL } from '../../config/Base_Url_Config';


const Order = () => {
  const [order, setOrder] = useState(null);
  const { id } = useParams();
  const invoiceRef = useRef(); // Reference for PDF content
  const [get_settings, set_get_settings] = useState({});

  const userData =
    localStorage.getItem("user") !== "undefined" &&
    JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/orders/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setOrder(response.data);
      } catch (error) {
        console.error("Order fetch error:", error);
      }
    };
    fetchOrder();
  }, [id]);

  useEffect(() => {
            const handle_get_settings = async () => {
                try {
                        const response = await get_settings_section();
                        set_get_settings(response?.data?.data?.settings)
                } catch (error) {
                        console.log("error", error)
                }
            }
            handle_get_settings();
    }, [])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!order) return <div style={{ textAlign: "center", padding: "2rem" }}>Loading...</div>;

  const recipient = order.items[0]?.order_type || "N/A";
  const principalPayment = parseFloat(order.total_price).toFixed(2);
  const feeAmount = (parseFloat(principalPayment) * 0.05).toFixed(2);
  const totalAmount = (parseFloat(principalPayment) + parseFloat(feeAmount)).toFixed(2);
  const date = new Date(order.created_at).toLocaleDateString();
  const clientName = userData?.name || "Client";
  const transactionDescription = recipient || "transactions";

  const handleDownloadPdf = () => {
    const element = invoiceRef.current;
    const options = {
      margin: 0.5,
      filename: `invoice-${order.id}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };
    html2pdf().set(options).from(element).save();
  };

  return (
    <>
      <Header />
      <div style={{ maxWidth: "1000px", margin: "auto", padding: "2rem", fontFamily: "Arial" }}>
        
        <div style={{ textAlign: "right", marginBottom: "1rem" }}>
          <button onClick={handleDownloadPdf} style={{ padding: "10px 20px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}>
            Download PDF
          </button>
        </div>

        {/* PDF Content Container */}
        <div ref={invoiceRef}>
            <div className="shadow-lg p-6">
            <div className="border-b-2 mb-3 pb-4">
          <Link to="/" className=" shrink-0 text-center">
                {
                    get_settings?.header_logo != null ? (
                            <img alt="Your Company" src={`${IMG_BASE_URL}/${get_settings?.header_logo}`} className="h-6 md:h-8 w-auto mx-auto" />
                    ) : (
                            <img alt="Your Company" src={logo} className="h-6 md:h-8 w-auto mx-auto" />
                    )
                }
        </Link>   
        </div>
          <h1 className="text-3xl font-bold pb-4" style={{ textAlign: "center" }}>Transaction Invoice</h1>
          <p><strong>Transaction ID:</strong> #{order.id}</p>
          <p>Dear {clientName},</p>
          <p>
            Finxera, Inc. is the payment processor for your {transactionDescription.toLowerCase()} managed by Locaknpay.
            We have made the below payment from your account, in accordance with your instructions.
          </p>
          <hr />
          <p><strong>Payment to:</strong> {recipient}</p>
          <p><strong>Total to Recipient:</strong> {principalPayment} USD</p>
          <p><strong>Transaction Fee:</strong> {feeAmount} USD</p>
          <p><strong>Total Transfer:</strong> {totalAmount} USD</p>
          <p><strong>Date:</strong> {date}</p>
          <hr />
          <h3>CONTACT US</h3>
          <p>
            You can reach out to us at <a href="mailto:support@prioritypassport.com">support@prioritypassport.com</a> or call customer support at (800) 475-0811.
          </p>
          <h3>RIGHT TO REFUND</h3>
          <p>
            You, the customer, are entitled to a refund of the money to be transmitted as a result of this agreement if Finxera does not forward the money received from you within 10 days of the date of its receipt, or does not give instructions committing an equivalent amount of money to the person designated by you within 10 days of the receipt of the funds from you unless otherwise instructed by you.
          </p>
          <p>
            If your instructions as to when the moneys shall be forwarded or transmitted are not complied with and the money has not yet been forwarded or transmitted, you have a right to a refund of your money.
          </p>
          <p>
            If you want a refund, you must mail or deliver your written request to Finxera at 2975 Regent Blvd, Suite 100, Lockbox Services 208677, Irving, TX 75063.
            If you do not receive your refund, you may be entitled to your money back, plus a penalty of up to $1,000 and attorney’s, fees pursuant to Section 2102 of the California Financial Code. *
          </p>
          <p><em>* This paragraph only applies to California residents.</em></p>
          <h3>For Texas Residents:</h3>
          <p>
            If you have a complaint, first contact Finxera at (800) 475-0811. If you still have an unresolved complaint regarding the company’s money transmission activity, please direct your complaint to: Texas Department of Banking, 2601 North Lamar Boulevard, Austin, Texas 78705, 1-877-276-5554 (toll free), <a href="https://www.dob.texas.gov" target="_blank" rel="noopener noreferrer">www.dob.texas.gov</a>.
          </p>
          <h3>For New York Residents:</h3>
          <p>
            If you have a complaint, first contact Finxera at (800) 475-0811. If you still have an unresolved complaint regarding the company’s money transmission activity, please direct your complaint to: New York State Department of Financial Services, Consumer Assistance Unit, One Commerce Plaza, Albany York, NY 12257, 1-800-342-3736, <a href="https://www.dfs.ny.gov" target="_blank" rel="noopener noreferrer">www.dfs.ny.gov</a>.
          </p>
          <p>
            You have a right to dispute errors in your transaction. If you think there is an error, contact us within 180 days at (800) 475-0811 or at 2975 Regent Blvd, Suite 100, Lockbox Services 208677, Irving, TX 75063. You can also contact us for a written explanation of your rights.
          </p>
          <p>
            Finxera, Inc. is a licensed provider of money transfer services (NMLS # 1168701) and is located at 2001 Westside Parkway, Suite 155, Alpharetta, GA 30004.
          </p>
          <p>
            See <a href="https://www.finxera.com/licensing" target="_blank" rel="noopener noreferrer">www.finxera.com/licensing</a> for additional disclosures.
          </p>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default Order;
